<header class="app-header">
    <div class="header-breadcrumb">
        <span class="material-icons-outlined text-[16px]">chevron_right</span>
        {{ currentPage() }}
    </div>
    <div class="header-actions">
        <div class="header-avatar uppercase">
            {{ userInfo()?.userName?.slice(0, 2) ?? '?' }}
        </div>
    </div>
</header>
